import React from 'react'
import PropTypes from 'prop-types'
import produce from 'immer'
import { get } from 'lodash'
import { compose } from 'redux'
import { connect } from 'react-redux'

import { withNamespaces } from '@edulastic/localization'
import { getFormattedAttrId } from '@edulastic/common/src/helpers'

import Question from '../../components/Question'

import {
  Layout,
  FontSizeOption,
  PlaceholderOption,
  MinHeightOption,
  MaxHeightOption,
} from '../../containers/WidgetOptions/components'
import { Row } from '../../styled/WidgetOptions/Row'
import { Col } from '../../styled/WidgetOptions/Col'

import { changeUIStyleAction } from '../../../author/src/actions/question'
import { setQuestionDataAction } from '../../../author/QuestionEditor/ducks'

const Display = ({
  item,
  changeUIStyle,
  setQuestionData,
  advancedAreOpen,
  fillSections,
  cleanSections,
  t,
}) => {
  const changeQuestion = (prop, updatedValue) => {
    setQuestionData(
      produce(item, (draft) => {
        draft[prop] = updatedValue
      })
    )
  }

  return (
    <Question
      section="advanced"
      label={t('component.options.display')}
      advancedAreOpen={advancedAreOpen}
      fillSections={fillSections}
      cleanSections={cleanSections}
    >
      <Layout
        id={getFormattedAttrId(
          `${item?.title}-${t('component.options.display')}`
        )}
      >
        <Row gutter={24}>
          <Col md={12}>
            <MinHeightOption
              onChange={(val) => changeUIStyle('minHeight', +val)}
              value={get(item, 'uiStyle.minHeight', 300)}
            />
          </Col>
          <Col md={12}>
            <MaxHeightOption
              onChange={(val) => changeUIStyle('maxHeight', +val)}
              value={get(item, 'uiStyle.maxHeight', 300)}
            />
          </Col>
        </Row>

        <Row gutter={24}>
          <Col md={12}>
            <PlaceholderOption
              onChange={(val) => {
                changeQuestion('placeholder', val)
              }}
              type="text"
              value={get(item, 'placeholder', '')}
            />
          </Col>
          <Col md={12}>
            <FontSizeOption
              onChange={(val) => changeUIStyle('fontsize', val)}
              value={get(item, 'uiStyle.fontsize', 'normal')}
            />
          </Col>
        </Row>
      </Layout>
    </Question>
  )
}

Display.propTypes = {
  item: PropTypes.object.isRequired,
  setQuestionData: PropTypes.func.isRequired,
  changeUIStyle: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
  fillSections: PropTypes.func,
  cleanSections: PropTypes.func,
  advancedAreOpen: PropTypes.bool,
}

Display.defaultProps = {
  advancedAreOpen: false,
  fillSections: () => {},
  cleanSections: () => {},
}

export default compose(
  withNamespaces('assessment'),
  connect(({ user }) => ({ user }), {
    changeUIStyle: changeUIStyleAction,
    setQuestionData: setQuestionDataAction,
  })
)(Display)
